var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrameGiga(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 146,
    viewBox: "0 0 108 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2850_689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M147.535 -61.1119C157.493 -43.7975 160.813 -27.8794 159.002 -14.4747C157.342 -1.20965 150.402 9.54202 154.627 22.3882C158.851 35.374 174.241 50.5939 179.522 69.4442C184.652 88.2946 179.824 110.775 165.49 110.356C151.307 109.798 127.77 86.3397 106.948 82.0111C86.126 77.6825 67.8693 92.6232 54.7425 92.4836C41.6158 92.4836 33.4681 77.4033 31.3558 62.8815C29.2434 48.2201 33.3173 34.2569 37.6928 22.5278C41.9175 10.6591 46.5949 1.30373 46.8967 -16.1503C47.0475 -33.6043 43.1246 -58.8778 51.8758 -76.8903C60.7778 -94.7632 82.5048 -105.096 101.667 -101.047C120.829 -96.9973 137.426 -78.4263 147.535 -61.1119Z",
    fill: "#EE4352",
    fillOpacity: 0.969
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2850_689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 211,
    fill: "white",
    transform: "translate(0 -65)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameGiga);
export default __webpack_public_path__ + "static/media/FrameGiga.f19354af.svg";
export { ForwardRef as ReactComponent };